import { getCoreDataSecurityApplicationsAllSlice } from './get';

export const { requestGetCoreDataSecurityApplicationsAll, resetGetCoreDataSecurityApplicationsAll } =
	getCoreDataSecurityApplicationsAllSlice.asyncActionCreators;
